import type { IconSvgObject } from './types';

const ThermometerColdIcon: IconSvgObject = [
  ["path", { d: "M17.5 22C19.7091 22 21.5 20.2091 21.5 18C21.5 16.5194 20.6956 15.2267 19.5 14.5351V4C19.5 2.89543 18.6046 2 17.5 2C16.3954 2 15.5 2.89543 15.5 4V14.5351C14.3044 15.2267 13.5 16.5194 13.5 18C13.5 20.2091 15.2909 22 17.5 22Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 9.5L6 11.5L4 13.5M11 6L9 8L7 6M11 16.5L9 14.5L7 16.5M11.5 11.5H2.5M9 4.5V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ThermometerColdIcon;
